import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, AfterViewInit, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';

// Constants
import { MasterConstants } from '../../../../common/constants/master-constants';

//Service
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { DealerService } from './../../../../services/seed/dealer.service';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { CommonService } from './../../../../services/common/common.service';
import { EaSwapProductSliderModelService } from '../ea-order/ea-swap-product/ea-swap-product-slider-model.service';
import { EaProductModifyDecreaseUnitSliderModelService } from '../ea-order/ea-product-modify-decrease-unit/ea-product-modify-decrease-unit-slider-model.service';
import { EaAddProductSliderModelService } from '../ea-order/ea-add-product/ea-add-product-slider-model.service';
//Component
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';

// View Model
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { DealerOrderItemVM } from './../../../../models/DealerOrderItemVM';
import { AccountVM } from './../../../../models/AccountMasterVM';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { OrderTransferService } from '../../../../services/seed/order-transfer.service';

@Component({
  selector: 'app-dealer-order-view',
  templateUrl: './dealer-order-view.component.html',
  styleUrls: ['./dealer-order-view.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})

export class DealerOrderViewComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private subscription = new Array<Subscription>();

  accountId: any;
  dealerOrderId: any;
  selectedDealerAccountNo: any;
  panelOpenState = false;

  dealerOrderItemDS: MatTableDataSource<any>;

  selAccountObj: AccountVM;

  dealerOrderData: any;
  updateTimestamp: any;
  dealerOrderItemList: any;
  totalRows = 2;

  partialSearchValue = '';
  productFilters: any;
  filterValueList: any = [];
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  productLineMasterList: any = [];
  searchValue = '';
  // productComponent: ProductAddComponent;
  productList = new Array();
  dealerOrderDS: MatTableDataSource<any>;
  filterDealerOrderDSitems: any[] = [];
  dealerOrderDSLength: number;
  productSearchFilter: string;
  headerYear: string;
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  isNotValidOrder = true;
  title: string;
  message: string;
  showAccInfo: Boolean;
  showGrowerInfo: Boolean;
  showProductDetails: Boolean;
  columnsToDisplay = ['checkbox', 'product', 'seedSize', 'treatment', 'packageSize', 'technology', 'availableUnit', 'longShort', 'dealerBucket', 'dealerUnit'];
  expandedElement: any | null;
  selectedCount = 0;
  editToolKit = false;
  isBusy = false;
  isSearchClicked = false;
  tabNode: string;
  addUpdateOpr: string;
  totalProduct = 0;
  totalDealerUnits = 0;

  errorMsgs = new Array();
  dealerOrderListCopy: any;
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  index = 0;
  hasChangeAdded = false;
  selectedOrderToOrderItemList = new Array();
  disablecheckbox = false;
  dealerOrderDataCopy: any;
  selectedBillingType: string;
  isReadOnly = false;
  userMenuAccessList: any;
  accessTypeMode = false;
  isAddProductAccess = false;
  isInternalTransfer = false;
  newlyAdded: any;
  concatedList: any;
  isEaUnitsEligible: boolean = false;
  isEaSwapEligible: boolean = false;
  isEaDecreaseEligible: boolean = false;
  isEaModifyEligible: boolean = false;
  isEaAddProductEligible: boolean = false;
  isEaUnitsExist: boolean = false;
  isUpdateButtonDisabled: boolean = false;
  isInternalTransferClicked: boolean = false;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  IsMobile = false;
  isInMobileApp = false;

  searchTypeList: any[] = [
    { name: 'Product Name', value: 'ProductNameFilter' },
    { name: 'Marketing Brand', value: 'marketingBrand' },
    { name: 'Seed Size', value: 'seedSize' },
    { name: 'Package Size', value: 'packageSize' },
    { name: 'Technology', value: 'technology' },
    { name: 'Treatment', value: 'treatment' },
    // { name: 'Maturity', value: 'maturity' },
    { name: 'Product Line', value: 'productLine' }
  ];

  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  accountEmail: string;
  isNotValid: any;
  showWarningOnUpdateButton = false;
  ignoreZeroQtyRecords = false;
  ignoreZeroEaUnitRecords = false;
  cutCancelCancellationMessage: string;
  isSubscriptionAccess = true;
  transferListToSubmit: any = [];
  isAccountRIB: boolean;
  minimumUnitsExceptionData: any;
  growerGMK: number;
  selectedDealerAccount: number;

  constructor(private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private dealerService: DealerService,
    private sliderModelService: SliderModelService,
    private dialog: MatDialog,
    private toastrService: ToastrService,
    public commonService: CommonService,
    private loaderService: LoaderService,
    private orderTransferService: OrderTransferService,
    private eaSwapProductSliderModelService: EaSwapProductSliderModelService,
    private eaProductModifyDecreaseUnitSliderModelService: EaProductModifyDecreaseUnitSliderModelService,
    private eaAddProductSliderModelService: EaAddProductSliderModelService) {
    this.showAccInfo = false;
    this.showGrowerInfo = false;
    this.showProductDetails = false;
    this.subscription.push(this.activatedRoute.paramMap.subscribe(params => {
      if (+(params.get('accountNo')) >= 0) {
        this.accountId = +(params.get('accountNo'));
      }
      if (+(params.get('dealerOrderId')) >= 0) {
        this.dealerOrderId = +(params.get('dealerOrderId'));
      }
      if (+(params.get('selectedDealerAccountNo')) >= 0) {
        this.selectedDealerAccountNo = +(params.get('selectedDealerAccountNo'));
      }
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.ACCOUNT_CHANGE).subscribe((data) => {
      if (data.hasAccountSelected != undefined) {
        this.selectedBillingType = data.hasAccountSelected;
      }
    }));

    this.subscription.push(this.router.events.subscribe((e: any) => {
      if (e && e.routerEvent instanceof NavigationEnd) {
        this.resetProductFilter();
        this.reInitialiseDealerCmp();
        this.isReadOnly = false;
        this.hasChangeAdded = false;
      }
    }));
    if (this.dealerOrderId == 0) {
      this.addUpdateOpr = 'Add';
    }
    else {
      this.addUpdateOpr = 'edit';
    }
    this.cutCancelCancellationMessage = MasterConstants.CUTCANCEL_CANCELLATION_MESSAGE;
  }

  displayedColumns: string[] = ['brand', 'dealerOrderID', 'shipToAccount'];

  displayedExpandColumns: string[] = ['growerOrderData'];

  // ngOnInit
  ngOnInit() {
    this.isInMobileApp = this.isInWebView();

    if (this.isMobile || this.isInMobileApp) {
      this.IsMobile = true;

      this.subscription.push(this.commonService.seedOrderGrowerGMK.subscribe(growerGMK => {
        if (growerGMK && growerGMK > 0) {
          this.growerGMK = growerGMK;
        }
      }));

      this.subscription.push(this.commonService.seedOrderDealerAccount.subscribe(ac => {
        if (ac && ac > 0) {
          this.selectedDealerAccount = ac;
        }
      }));

    }
    this.productSearchFilter = this.searchTypeList[0].value;

    this.bindDataSource([], true, true);

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isSubscriptionAccess = true;
        }
      }
    }

    this.subscription.push(this.sliderModelService.modelData.subscribe(x => {
      if (x != null && x.selectedProductList) {
        this.convertDataToPass(x.selectedProductList);
      }

      if (x instanceof Array) {
        this.convertDataForDS(x);
        if (this.hasChangeAdded == true) {
          this.editToolKit = false;
          this.isReadOnly = true;
        }
      }
    }));

    this.subscription.push(this.sliderModelService.modelData2.subscribe(result => {
      if (result != null && result.validateResponse != null && result.transferList != null) {
        this.transferListToSubmit = result.transferList;
        let transferList = result.validateResponse.calculatedList;
        this.bindTransferList(transferList);
      }
    }));

    this.subscription.push(this.sliderModelService.modelData3.subscribe(result => {
      if (result != null && result.validateResponse != null && result.transferList != null) {
        this.transferListToSubmit = result.transferList;
        let transferList = result.validateResponse.calculatedList;
        this.bindTransferList(transferList);
      }
    }));

    this.resetProductFilter();
    this.AddProductAccess();
    this.CheckInternalTransfer();

    if (this.dealerOrderDS.data.length > 0) {
      this.dealerOrderDS.data.forEach(x => {
        this.blockHideShow(x.rowId, false);
      });
    }

    this.accessTypeMode = false;
    setTimeout(x => {
      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (evolveAccessData) {
          this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
          this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
        }
      }
    }, 500);

    // Check for EA functionality
    this.isEaUnitsEligible = JSON.parse(this.localStorageService.get(MasterConstants.SEED_EA_ACCESS)) ? true : false;

    if (this.isEaUnitsEligible) {
      this.columnsToDisplay = ['checkbox', 'product', 'seedSize', 'treatment', 'packageSize', 'availableUnit', 'longShort', 'dealerBucket', /* AC1: Removed 'eaUnits', */ 'dealerUnit'];
      this.searchTypeList = [
        { name: 'Product Name', value: 'ProductNameFilter' },
        { name: 'Marketing Brand', value: 'marketingBrand' },
        { name: 'Seed Size', value: 'seedSize' },
        { name: 'Package Size', value: 'packageSize' },
        { name: 'Treatment', value: 'treatment' },
        // { name: 'Maturity', value: 'maturity' },
        { name: 'Product Line', value: 'productLine' }
      ];
      this.setEaAccess();                 // set EA Access for account.
    }
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // ngOnChanges
  ngOnChanges() {
    this.setHeight();
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.IsMobile) {
      this.commonService.setSeedOrderGrowerGMK(0);
      this.commonService.setSeedOrderDealerAccount(0);
    }
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Set page height
  setHeight() {
    const templateHeight = window.innerHeight - $('.search-section').outerHeight() - 76;
    $('.order-view-sec').css('max-height', templateHeight + 'px');

    const GrowerAddSecHeight = window.innerHeight - $('.search-section').outerHeight() - 96;
    $('.order-view-sec .grower-add-sec').css('min-height', GrowerAddSecHeight + 'px');
  }

  // Load Master Data
  loadMasterData() {
    // Product master data
    // if (this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST)) {
    //  this.productMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST));
    // }

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
  }

  // re Initialise Dealer
  reInitialiseDealerCmp() {
    this.productSearchFilter = this.searchTypeList[0].value;
    this.subscription.push(this.activatedRoute.paramMap.subscribe(params => {
      if (+(params.get('accountNo')) >= 0) {
        this.accountId = +(params.get('accountNo'));
      }
      if (+(params.get('dealerOrderId')) >= 0) {
        this.dealerOrderId = +(params.get('dealerOrderId'));
      }
      if (+(params.get('selectedDealerAccountNo')) >= 0) {
        this.selectedDealerAccountNo = +(params.get('selectedDealerAccountNo'));
      }
      else {
        this.dealerOrderId = 0;
      }
    }));

    if (this.dealerOrderId == 0) {
      this.addUpdateOpr = 'Add';
    }
    else {
      this.addUpdateOpr = 'edit';
    }

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    this.getDealerDetail();
    this.getDealerOrderDetail();
    this.getDealerOrderItemsList();

    this.errorMsgs = new Array();
  }

  // SET EA ACCESS for to account
  setEaAccess() {
    const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    if (evolveAccessData) {
      this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
      this.isEaSwapEligible = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_EARLY_ADVANTAGE_SWAP_PRODUCT, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
      this.isEaDecreaseEligible = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_EARLY_ADVANTAGE_DECREASE_PRODUCT, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
      this.isEaModifyEligible = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_EARLY_ADVANTAGE_MODIFY_PRODUCT, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
      this.isEaAddProductEligible = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_EARLY_ADVANTAGE_ADD_PRODUCT, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
    }
  }

  // Open Add item popup
  openAddItem() {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      this.sliderModelService.initializeProductChangeVal({
        companyCode: this.headerCompany,
        cropYear: +this.headerYear,
        accountNo: +this.selectedDealerAccountNo,
        action: '',
        page: 'dealerOrder',
        data: [],
        dealerData: [],
        isAccountRIB: false
      });

      this.sliderModelService.initializeComponentVal(this.selectedDealerAccountNo);
      this.sliderModelService.activeSlider('AddProductSlider');
      this.sliderModelService.selectedPerson('Dealer');
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  // Open modify item popup
  openModifyItem(action: string) {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      const datalst = this.filterDealerOrderDSitems.filter(x => x.isSelected && x.dealerOrderItemId == 0);

      const data = this.filterDealerOrderDSitems.filter(x => x.isSelected);
      data.forEach(x => {
        x.modifiableUnit = 0;
        x.modifiableUnit = (x.netBEU - x.plannedUnits - x.shippedUnits);
      });
      const lst = data.filter(x => x.isSelected && x.modifiableUnit != 0);
      if (lst && lst.length == 0) {
        this.toastrService.warning('No Item found with Modifiable Units.');
        return false;
      }

      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });

        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.revertToPreviousState(false);
            this.sliderModelService.initializeProductChangeVal({
              companyCode: this.headerCompany,
              cropYear: +this.headerYear,
              accountNo: +this.selectedDealerAccountNo,
              action: action,
              page: 'dealerSlider',
              data: [],
              dealerData: lst as DealerOrderItemVM[],
              isAccountRIB: this.isAccountRIB
            });

            this.sliderModelService.activeSlider('ChangeProductSlider');
            this.tabNode = '';
          }
        }));
      }
      else {
        this.sliderModelService.initializeProductChangeVal({
          companyCode: this.headerCompany,
          cropYear: +this.headerYear,
          accountNo: +this.selectedDealerAccountNo,
          action: action,
          page: 'dealerSlider',
          data: [],
          dealerData: lst as DealerOrderItemVM[],
          isAccountRIB: this.isAccountRIB
        });

        this.sliderModelService.activeSlider('ChangeProductSlider');
        this.tabNode = '';
      }
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  // Revert to previous
  revertToPreviousState(isCheckBoxRevert: boolean) {
    if (isCheckBoxRevert) {
      this.dealerOrderDataCopy.forEach(item => {
        item.isSelected = false;
      });
    }
    else {
      const checkedIds = [];
      const growerDsItems = JSON.parse(JSON.stringify(this.dealerOrderDS.data));

      for (let i = 0; i < growerDsItems.length; i++) {
        if (growerDsItems[i].isSelected == true
          && growerDsItems[i].dealerOrderItemId > 0) {
          checkedIds.push(growerDsItems[i].dealerOrderItemId);
        }
      }

      this.dealerOrderDataCopy.forEach(item => {
        if (checkedIds.length > 0
          && item.dealerOrderItemId > 0
          && checkedIds.includes(item.dealerOrderItemId)) {
          item.isSelected = true;
        }
        else {
          item.isSelected = false;
        }
      });
    }

    this.isReadOnly = false;
    this.errorMsgs = new Array();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
    this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.dealerOrderDataCopy));
    this.bindDataSource(this.dealerOrderDS.data, true, true);
    this.clearAllFilter();
  }

  // Cancel dealer order
  CancelDealerOrder() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.revertToPreviousState(true);
          this.ignoreZeroQtyRecords = false;
          this.ignoreZeroEaUnitRecords = false;
          this.showWarningOnUpdateButton = false;
          this.isUpdateButtonDisabled = false;
        }
      }));
    }
    else {
      this.revertToPreviousState(true);
      this.loaderService.setLoaderStatus(true);
      setTimeout(x => { this.loaderService.setLoaderStatus(false); }, 200);
    }
  }

  // ConvertDataToPass
  convertDataToPass(productList: any[]) {
    const orderList = [];

    this.dealerOrderDS.data.forEach(x => orderList.push(x));

    const groupData = orderList.filter(y => y.isGroupBy == true);

    let id = 0;

    productList.forEach(x => {
      const duplicateData = orderList.find(y => y.itemID == x.itemId);
      if (duplicateData == undefined) {
        // added temp Id
        id = id + 1;
        const newRow = {
          ProductNameFilter: (x.brand != null ? x.brand : ''),
          brand: x.brand,
          conv: x.conv,
          isSelected: true,
          dealerUnits: 0,
          growerOrderInfoVM: null,
          highlightTechnology: x.highlightTechnology,
          highlightPackage: x.highlightPackage,
          highlightTreatment: x.highlightTreatment,
          itemDescription: x.itemDescription,
          dealerOrderItemId: 0,
          itemID: x.itemId,
          itemNumber: x.itemNumber,
          longShortPosition: x.longShortPosition,
          marketingBrand: x.marketingBrand,
          maturity: x.maturity,
          myDealerBucketQty: x.myDealerBucketQty,
          myDealerBucket: x.myDealerBucket,
          netBEU: x.netBEU,
          netGEU: x.netGEU,
          packageSize: x.packageSize,
          plannedUnits: x.plannedUnits,
          eaModifiableUnits: x.eaModifiableUnits,
          eaShippedUnits: x.eaShippedUnits,
          eaPlannedUnits: x.eaPlannedUnits,
          productLine: x.productLine,
          seedAvailability: x.seedAvailability,
          seedSize: x.seedSize,
          shipToAccount: x.shipToAccount,
          shippedUnits: x.shippedUnits,
          softCommitUnits: x.softCommitUnits,
          technology: x.technology,
          treatment: x.treatment,
          isGroupBy: false,
          primaryUOM: x.primaryUOM,
          secondaryUOM: x.secondaryUOM,
          isProductDeactivated: x.isProductDeactivated,
          deactivationType: x.deactivationType,
          isHighDemand: x.isHighDemand,
          ChangeType: 'ADD',
          seedNonReturnable: x.seedNonReturnable,
          isEaReducedModifiableChecked: false
        };
        const groupDetail = groupData.find(y => y.productLine == x.productLine);

        if (groupDetail != undefined) {
          let validate = false, rowId = 0;
          groupData.forEach(function (gd) {
            if (validate == true) {
              return;
            }
            if (gd.productLine == x.productLine) {
              validate = true;
              rowId = gd.rowId;
            }
          });

          orderList.splice(rowId, 0, newRow);
        }
        else {
          const newGroup = { isGroupBy: true, productLine: x.productLine, ProductNameFilter: '' };
          groupData.push(newGroup);
          orderList.splice(orderList.length, 0, newGroup);
          orderList.splice(orderList.length, 0, newRow);
        }

        orderList.sort(function (a, b) {
          const nameA = a.productLine.toLowerCase(), nameB = b.productLine.toLowerCase();
          if (nameA < nameB) // sort string ascending
          { return -1; }
          if (nameA > nameB) { return 1; }
          return 0; // default return value (no sorting)
        });

        if (orderList.length > 0) {
          let newRowId: Number = 0;
          orderList.forEach(x => {
            newRowId = +newRowId + 1;
            x.rowId = +newRowId;
            x.totalRows = 2;
          });
        }
      }
    });
    this.onClose(orderList, true);
  }

  // ConvertDataToPass
  convertDataForDS(productList: any[]) {
    const orderList = [];

    this.dealerOrderDS.data.forEach(x => {
      if (!x.isSelected) {
        orderList.push(x);
      }
    });
    const groupData = orderList.filter(y => y.isGroupBy == true);
    let id = 0;
    productList.forEach(x => {
      x.isSelected = true;
      const duplicateData = orderList.find(y => y.itemID == x.itemID);
      if (duplicateData == undefined) {
        // added temp Id
        id = id + 1;
        const newRow = {
          ProductNameFilter: (x.brand != null ? x.brand : ''),
          brand: x.brand,
          conv: x.conv,
          dealerUnits: x.geu,
          growerOrderInfoVM: null,
          highlightPackage: x.highlightPackage,
          highlightTechnology: x.highlightTechnology,
          highlightTreatment: x.highlightTreatment,
          itemDescription: x.itemDescription,
          itemID: x.itemID,
          dealerOrderItemId: x.dealerOrderItemId,
          itemNumber: x.itemNumber,
          longShortPosition: x.longShortPosition,
          marketingBrand: x.marketingBrand,
          maturity: x.maturity,
          myDealerBucketQty: x.myDealerBucketQty,
          myDealerBucket: x.myDealerBucket,
          netBEU: x.netBEU,
          netGEU: x.netGEU,
          packageSize: x.packageSize,
          plannedUnits: x.plannedUnits,
          eaModifiableUnits: x.eaModifiableUnits,
          eaShippedUnits: x.eaShippedUnits,
          eaPlannedUnits: x.eaPlannedUnits,
          productLine: x.productLine,
          seedAvailability: x.seedAvailability,
          seedSize: x.seedSize,
          shipToAccount: x.shipToAccount,
          shippedUnits: x.shippedUnits,
          softCommitUnits: x.softCommitUnits,
          technology: x.technology,
          treatment: x.treatment,
          isGroupBy: false,
          primaryUOM: x.primaryUOM,
          secondaryUOM: x.secondaryUOM,
          isSelected: x.isSelected,
          ChangeType: x.ChangeType,
          isProductDeactivated: x.isProductDeactivated,
          deactivationType: x.deactivationType,
          seedNonReturnable: x.seedNonReturnable,
          eaUnits: x.eaUnits,
          dealerModifiableUnits: x.dealerModifiableUnits,
          stockTransferUnits: x.stockTransferUnits,
          isEAModifiableChecked: x.isEAModifiableChecked,
          itemGroup: x.itemGroup
        };
        const groupDetail = groupData.find(y => y.productLine == x.productLine);

        if (groupDetail != undefined) {
          let validate = false, rowId = 0;
          groupData.forEach(function (gd) {
            if (validate == true) {
              return;
            }
            if (gd.productLine == x.productLine) {
              validate = true;
              rowId = gd.rowId;
            }
          });

          orderList.splice(rowId, 0, newRow);
        }
        else {
          const newGroup = { isGroupBy: true, productLine: x.productLine, ProductNameFilter: '' };
          groupData.push(newGroup);
          orderList.splice(orderList.length, 0, newGroup);
          orderList.splice(orderList.length, 0, newRow);
        }

        orderList.sort(function (a, b) {
          const nameA = a.productLine.toLowerCase(), nameB = b.productLine.toLowerCase();
          if (nameA < nameB) // sort string ascending
          { return -1; }
          if (nameA > nameB) { return 1; }
          return 0; // default return value (no sorting)
        });

        if (orderList.length > 0) {
          let newRowId: Number = 0;
          orderList.forEach(x => {
            newRowId = +newRowId + 1;
            x.rowId = +newRowId;
            x.totalRows = 2;
          });
        }
      }
      else {
        if (x.dealerOrderItemId > 0) {
          duplicateData.dealerOrderItemId = x.dealerOrderItemId;
        }
        duplicateData.isEAModifiableChecked = x.isEAModifiableChecked;
        duplicateData.itemGroup = x.itemGroup;
        duplicateData.eaUnits = x.eaUnits;
        duplicateData.eaModifiableUnits = x.eaModifiableUnits;
        duplicateData.dealerUnits = Number(duplicateData.dealerUnits) + Number(x.geu);
      }
    });

    this.onClose(orderList, false);
  }

  // Close action on click of add product component
  onClose(selectedProductList: any[], isPopupAction): void {
    this.errorMsgs = new Array();
    if (selectedProductList.length > 0) {
      let rowId: Number = 0;
      selectedProductList.forEach(x => {
        rowId = +rowId + 1;
        x.rowId = +rowId;
        x.lineErrors = { 'rowId': x.rowId, 'errors': [] };
        // x.ChangeType = 'ADD';
      });
      this.newlyAdded = selectedProductList.filter(i => i.dealerOrderItemId == 0 && i.ChangeType == 'ADD');
    }

    if (selectedProductList.length > 0) {
      this.bindDataSource(selectedProductList, true, false);
      this.isNotValidOrder = false;
      if (isPopupAction == true) {
        this.activeEditToolKit(true);
        this.ignoreZeroQtyRecords = false;
        if (this.isEaUnitsEligible) {
          this.ignoreZeroEaUnitRecords = false;
          this.filterEADealerOrderDetail(false);
        }
        this.filterDealerOrderDetail(false);
      }
    }

    this.sliderModelService.close();
  }

  // Get dealer details
  getDealerDetail() {
    this.subscription.push(this.dealerService.getDealerDetail(this.selectedDealerAccountNo, this.headerYear).subscribe(results => {
      this.selAccountObj = results as any;
      this.accountId = this.selAccountObj.accountNumber;
      this.isAccountRIB = this.selAccountObj.isAccountRIB;
      this.loadMasterData();
      if (this.selAccountObj
        && this.selAccountObj.billingAddressType) {
        this.selectedBillingType = this.selAccountObj.billingAddressType;
      }
      if (this.selAccountObj) {
        this.broadcastService.broadcast(this.configService.PARAM_DEALER_ORDER, { accountNo: this.selectedDealerAccountNo, dealerOrderId: this.dealerOrderId, selectedDealerObj: this.selAccountObj });
      }
    }, (error => {
      LolLoggerService.error(error);
    })));
  }

  // Get Dealer order details
  getDealerOrderDetail() {
    this.dealerOrderData = null;
    if (this.dealerOrderId != undefined && this.dealerOrderId != 0) {
      this.subscription.push(this.dealerService.getDealerOrderDetail(this.dealerOrderId).subscribe(results => {
        this.dealerOrderData = results;
        if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
          const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
          if (data !== null && data !== undefined && data.resultData.length > 0) {
            const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
            if (isActiveUser.isSubscriptionAccess) {
              this.accountEmail = results.emailAddress;
            }
          }
        }
      }, (error => {
        LolLoggerService.error(error);
      })));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.accountEmail = isActiveUser.emailId;
        }
      }
    }
  }

  // Get dealer order item list
  getDealerOrderItemsList() {
    this.ignoreZeroQtyRecords = false;
    if (this.isEaUnitsEligible) {
      this.ignoreZeroEaUnitRecords = false;
    }
    if (this.accountId == undefined || this.accountId == null) {
      this.accountId = 0;
    }

    if (this.dealerOrderId == undefined || this.dealerOrderId == null) {
      this.dealerOrderId = 0;
    }

    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.dealerService.getDealerOrderItems(this.headerYear, this.accountId, this.dealerOrderId).subscribe(results => {
      this.dealerOrderItemList = results;
      let rowId: Number = 0;

      this.dealerOrderItemList.forEach(product => {
        product.ProductNameFilter = (product.brand != null ? product.brand : '');
        rowId = +rowId + 1;
        // need to remove :
        product.rowId = +rowId;
        product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
        product.totalRows = 2;
        product.ChangeType = 'CHG';
        product.originalDealerUnits = product.dealerUnits;
        product.isLessDealerUnits = false;
        product.cutCancelOverWarning = false;
        product.cutOverWarning = false;
        product.showCutCancelOverWarning = false;
        product.showCutOverWarning = false;
        if (product.cutCancelOverDate != null) {
          const currentDate = new Date();
          const cutCancelDate = new Date(product.cutCancelOverDate);
          cutCancelDate.setSeconds(cutCancelDate.getSeconds() + 86399);
          if (currentDate > cutCancelDate) {
            product.cutCancelOverWarning = true;
          }
        }
        if (product.cutOverDate != null) {
          const currentDate = new Date();
          const cutOverDate = new Date(product.cutOverDate);
          cutOverDate.setSeconds(cutOverDate.getSeconds() + 86399);
          if (currentDate > cutOverDate) {
            product.cutOverWarning = true;
          }
        }
      });

      this.bindDataSource(this.dealerOrderItemList, true, true);
      this.EnableAllEditToolKit(false);
      this.loaderService.setLoaderStatus(false);
      this.GetEaMinimumUnitException();
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Bind the Grower order detail on expand click in dealer order
  getDealerGrowerDetail(obj) {
    if (obj.shipToAccount) {
      this.subscription.push(this.dealerService.getDealerGrowerDetail(this.headerYear, obj.itemID, obj.shipToAccount).subscribe(results => {
        obj.growerOrderInfoVM = results;
        obj.totalRows = 2;
      }, (error => {
        LolLoggerService.error(error);
      })));
    }
  }

  // Dealer unit change and validation
  dealerUnitChange(action: string, productItem: any) {
    // get old data

    const oldProductLineValue = JSON.parse(JSON.stringify(this.dealerOrderListCopy)).filter(x => x.rowId == productItem.rowId && x.itemID == productItem.itemID)[0];

    if (!productItem.dealerUnits) {
      productItem.dealerUnits = 0;
    }
    if (action == 'decrease'
      && (productItem.isProductDeactivated === false
        || (productItem.deactivationType == null || productItem.deactivationType.trim().toLowerCase() == 'partial'))) {
      const decValue = +productItem.dealerUnits - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.dealerUnits;
        productItem.dealerUnits = Math.floor(productItem.dealerUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.dealerUnits) {
          productItem.dealerUnits = (+productItem.dealerUnits > +productItem.conv ? +productItem.dealerUnits - +productItem.conv : 0);
        }
        if (productItem.cutCancelOverWarning) {
          if (this.dealerOrderDataCopy) {
            this.dealerOrderDataCopy.forEach(y => {
              if (y.itemID == productItem.itemID) {
                if (productItem.dealerUnits < y.dealerUnits) {
                  productItem.showCutCancelOverWarning = productItem.cutCancelOverWarning;
                }
              }
            });
          }
        }
      }
      else {
        productItem.dealerUnits = 0;
      }
    }
    else {
      if (productItem.isProductDeactivated === false
        || (productItem.deactivationType == null
          || productItem.deactivationType.trim().toLowerCase() != 'partial')) {
        var valueBeforeInc = productItem.dealerUnits;
        productItem.dealerUnits = Math.ceil(productItem.dealerUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeInc == productItem.dealerUnits) {
          productItem.dealerUnits = (+productItem.dealerUnits + +productItem.conv);
        }
        if (this.dealerOrderDataCopy) {
          this.dealerOrderDataCopy.forEach(y => {
            if (y.itemID == productItem.itemID) {
              if (productItem.dealerUnits >= y.dealerUnits) {
                productItem.showCutCancelOverWarning = false;
              }
            }
          });
        }
      }

      if (productItem.deactivationType != null && productItem.deactivationType.trim().toLowerCase() == 'partial') {
        var valueBeforeInc = oldProductLineValue.dealerUnits;
        const dealerUnits = Math.ceil(productItem.dealerUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeInc == dealerUnits) {
          productItem.dealerUnits = +dealerUnits;
        }
        else {
          productItem.dealerUnits = (+dealerUnits + +productItem.conv);
        }
        if (this.dealerOrderDataCopy) {
          this.dealerOrderDataCopy.forEach(y => {
            if (y.dealerOrderItemId == productItem.dealerOrderItemId) {
              if (productItem.dealerUnits >= y.dealerUnits) {
                productItem.showCutCancelOverWarning = false;
              }
            }
          });
        }
      }
    }

    if (productItem.isProductDeactivated === false
      || (productItem.deactivationType == null
        || productItem.deactivationType.trim().toLowerCase() == 'partial')) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldGeuValue: oldProductLineValue.dealerUnits, newGeuValue: productItem.dealerUnits });

      this.setCount();
      // TODO: Commented error handling to validate later
      this.validateLineItem(productItem, 'dealerUnit', action);
      if (productItem.isSelected != true) {
        productItem.isSelected = true;
        this.activeEditToolKit(true);
      }
    }


    this.dealerOrderDS.data.filter(i => i.rowId == productItem.rowId && i.itemID == productItem.itemID)[0].dealerUnits = productItem.dealerUnits;
  }

  // Add the dealer order product
  addDealerOrder() {
    // reset scroll top
    $('#orderView').animate({
      scrollTop: 0
    }, 'slow');

    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      this.isBusy = true;
      this.errorMsgs = new Array();
      this.loaderService.setLoaderStatus(true);

      if (this.validateOrder('')) {
        const data = [];
        this.dealerOrderDS.data.forEach(item => {
          if (item.isGroupBy != true) {
            data.push({
              companyCode: this.headerCompany,
              cropYear: this.headerYear,
              dealerOrderNumber: (item.dealerOrderNumber && item.dealerOrderNumber != '') ? item.dealerOrderNumber : '',
              itemId: item.itemID,
              itemNumber: item.itemNumber,
              accountId: this.selectedDealerAccountNo,
              quantity: item.dealerUnits,
              uOM: item.primaryUOM,
              secondaryUOM: item.secondaryUOM,
              // transactionQty: (item.dealerUnits == 0 ? 0 : (item.dealerUnits / item.conv)),
              transactionQty: item.dealerUnits,
              lineNumber: (item.dealerOrderNumber && item.dealerOrderNumber != '') ? item.lineNumber : '',
              updatedBy: '',
              ChangeType: item.ChangeType,
              EmailTo: this.accountEmail
            });
          }
        });

        if (data) {
          this.subscription.push(this.dealerService.dealerOrderAdd(data).subscribe((result: any) => {
            if (result && result.dealerOrderId != 0) {
              this.dealerOrderId = result.dealerOrderId as number;
              const msg = 'Dealer Order #' + result.orderNumber + ' saved successfully.';
              this.router.navigate(['/orders/dealer-order-view', this.accountId, this.dealerOrderId, this.selectedDealerAccountNo]);
              this.isBusy = false;
              this.toastrService.success(msg);
            }
            // TODO: Commented Server side error handling code -- Ashutosh
            else {
              // To get items from the current grid
              const itemIds = this.dealerOrderDS.data.filter(function (x) { return x.isGroupBy != true; }).map(y => y.itemID);

              // To get all deleted items from clone copy
              const deletedItems = this.dealerOrderListCopy.filter(function (obj) {
                return (itemIds.indexOf(obj.itemID) == -1 && obj.isGroupBy != true);
              });

              // Adding deleted items from the grid
              if (deletedItems && deletedItems.length > 0) {
                deletedItems.forEach(data => {
                  this.dealerOrderDS.data.push(JSON.parse(JSON.stringify(data)));
                });
                this.dealerOrderDS.data.sort((x, y) => x.rowId - y.rowId);
              }

              // Adding Error in existing data grid
              this.dealerOrderDS.data.forEach(data => {
                data.lineErrors.errors = [];
                if (data.isGroupBy != true) {
                  const itemErrors = result.dealerOrderItems.find(result => result.itemId == data.itemID);
                  if (itemErrors) {
                    data.dealerModifiableUnits = itemErrors.modifiableUnit ? itemErrors.modifiableUnit : data.dealerModifiableUnits;
                    data.seedAvailability = itemErrors.availability ? itemErrors.availability : data.seedAvailability;
                    itemErrors.errors.forEach(itemError => {
                      data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });

                      if (data.lineErrors.errors.length > 0) {
                        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                        this.errorMsgs.push(data.lineErrors);
                        this.getCommonErrors(this.errorMsgs);
                      }
                    });
                    // Added updated modifiable unit and availability in clone object to handle issue while revert changes
                    const oldData = this.dealerOrderListCopy.find(x => x.itemID == data.itemID);

                    if (oldData) {
                      oldData.dealerModifiableUnits = data.dealerModifiableUnits;
                      oldData.seedAvailability = data.seedAvailability;
                    }

                    // Added updated modifiable unit and availability in first copy object to handle issue while cancel changes
                    const firstData = this.dealerOrderDataCopy.find(x => x.itemID == data.itemID);

                    if (firstData) {
                      firstData.dealerModifiableUnits = data.dealerModifiableUnits;
                      firstData.seedAvailability = data.seedAvailability;
                    }
                  }
                }
                this.isBusy = false;
              });

              this.bindDataSource(this.dealerOrderDS.data, false, false);
            }
            this.loaderService.setLoaderStatus(false);
            this.isReadOnly = false;
          }, (error => {
            LolLoggerService.error(error);
            this.loaderService.setLoaderStatus(false);
          })));
        }
      }
      else {
        this.isBusy = false;
        this.showHideLineError(0);
        this.loaderService.setLoaderStatus(false);
        this.isReadOnly = false;
      }

      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  // Update the dealer order product
  updateDealerOrder() {
    if (!this.validateEmail()) {
      // reset scroll top
      $('#orderView').animate({
        scrollTop: 0
      }, 'slow');
      if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
        this.errorMsgs = new Array();
        this.loaderService.setLoaderStatus(true);

        if (this.validateOrder('')) {
          const data = [];
          this.dealerOrderDS.data.forEach(item => {
            if (item.isGroupBy != true) {
              data.push({
                companyCode: this.headerCompany,
                cropYear: this.headerYear,
                dealerOrderNumber: this.dealerOrderData.orderNumber,
                itemId: item.itemID,
                itemNumber: item.itemNumber,
                accountId: this.selectedDealerAccountNo,
                quantity: item.dealerUnits,
                uOM: item.primaryUOM,
                secondaryUOM: item.secondaryUOM,
                // transactionQty: (item.dealerUnits == 0 ? 0 : (item.dealerUnits / item.conv)),
                transactionQty: item.dealerUnits,
                lineNumber: (item.dealerOrderNumber && item.dealerOrderNumber != '') ? item.lineNumber : '',
                updatedBy: '',
                ChangeType: item.ChangeType,
                EmailTo: this.accountEmail,
                isEAModifiableChecked: item.isEAModifiableChecked,
                itemGroup: item.itemGroup,
                isEaReducedModifiableChecked: item.isEaReducedModifiableChecked,
                originalDealerUnits: item.originalDealerUnits,
                eaModifiableUnits: item.eaModifiableUnits
              });
            }
          });
          if (data.length == 0) {
            data.push({
              companyCode: this.headerCompany,
              cropYear: this.headerYear,
              dealerOrderNumber: this.dealerOrderData.orderNumber,
              accountId: this.selectedDealerAccountNo,
              EmailTo: this.accountEmail
            });
          }

          if (data) {
            this.subscription.push(this.dealerService.dealerOrderUpdate(data).subscribe((result: any) => {
              if (result && ((result.dealerOrderId == 0 && result.dealerOrderItems.length == 0) || result.dealerOrderId != 0)) {
                const message = 'Dealer Order #' + this.dealerOrderData.orderNumber + ' updated successfully.';
                this.dealerOrderId = result.dealerOrderId as number;
                this.router.navigate(['/orders/dealer-order-view', this.accountId, this.dealerOrderId, this.selectedDealerAccountNo]);

                this.isBusy = false;
                this.toastrService.success(message);
                this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
              }
              // TODO: Commented Server side error handling code -- Ashutosh
              else {
                // To get items from the current grid
                const itemIds = this.dealerOrderDS.data.filter(function (x) { return x.isGroupBy != true; }).map(y => y.itemID);

                // To get all deleted items from clone copy
                const deletedItems = this.dealerOrderListCopy.filter(function (obj) {
                  return (itemIds.indexOf(obj.itemID) == -1 && obj.isGroupBy != true);
                });

                // Adding deleted items from the grid
                if (deletedItems && deletedItems.length > 0) {
                  deletedItems.forEach(data => {
                    this.dealerOrderDS.data.push(JSON.parse(JSON.stringify(data)));
                  });
                  this.dealerOrderDS.data.sort((x, y) => x.rowId - y.rowId);
                }

                // Adding Error in existing data grid
                this.dealerOrderDS.data.forEach(data => {
                  data.lineErrors.errors = [];
                  if (data.isGroupBy != true) {
                    const itemErrors = result.dealerOrderItems.find(result => result.itemId == data.itemID);
                    if (itemErrors) {
                      data.dealerModifiableUnits = itemErrors.modifiableUnit ? itemErrors.modifiableUnit : data.dealerModifiableUnits;
                      data.seedAvailability = itemErrors.availability ? itemErrors.availability : data.seedAvailability;
                      itemErrors.errors.forEach(itemError => {
                        data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });

                        if (data.lineErrors.errors.length > 0) {
                          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                          this.errorMsgs.push(data.lineErrors);
                          this.getCommonErrors(this.errorMsgs);
                        }
                      });
                      // Added updated modifiable unit and availability in clone object to handle issue while revert changes
                      const oldData = this.dealerOrderListCopy.find(x => x.itemID == data.itemID);

                      if (oldData) {
                        oldData.dealerModifiableUnits = data.dealerModifiableUnits;
                        oldData.seedAvailability = data.seedAvailability;
                      }

                      // Added updated modifiable unit and availability in first copy object to handle issue while cancel changes
                      const firstData = this.dealerOrderDataCopy.find(x => x.itemID == data.itemID);

                      if (firstData) {
                        firstData.dealerModifiableUnits = data.dealerModifiableUnits;
                        firstData.seedAvailability = data.seedAvailability;
                      }
                    }
                  }
                });
                this.bindDataSource(this.dealerOrderDS.data, false, false);
                this.isBusy = false;
              }
              this.loaderService.setLoaderStatus(false);
              this.isReadOnly = false;
            }, (error => {
              LolLoggerService.error(error);
              this.loaderService.setLoaderStatus(false);
            })));
          }
        }
        else {
          this.isBusy = false;
          this.showHideLineError(0);
          this.loaderService.setLoaderStatus(false);
          this.isReadOnly = false;
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        }
      }
      else {
        this.toastrService.warning('Account not eligible for Ordering.');
      }
    }
    else {
      this.toastrService.warning('Enter a valid email.');
    }
  }

  // transfer dealer order
  transferDealerOrder() {
    if (this.isInternalTransfer && this.isInternalTransferClicked) {
      this.transferInternalDealerOrder();
      return;
    }
    this.loaderService.setLoaderStatus(true);
    let fromOrderId = this.transferListToSubmit[0].FromOrderId;

    this.subscription.push(this.orderTransferService.transferDealerOrder(this.transferListToSubmit).subscribe((result: any) => {
      if (result && result.dealerOrderId != 0) {
        this.transferListToSubmit = [];
        this.toastrService.success('Your order has been saved');
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        this.router.navigate(['/orders/dealer-order-view', 0, +fromOrderId, this.accountId]);
      }
      else {
        this.toastrService.error(result.errorMessage, '', {
          enableHtml: true
        });
        this.isUpdateButtonDisabled = true;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); }));
  }

  transferInternalDealerOrder() {
    if (this.transferListToSubmit.length > 0) {
      this.loaderService.setLoaderStatus(true);
      let fromOrderId = this.transferListToSubmit[0].FromOrderId;
      this.orderTransferService.transferInternalDealerOrder(this.transferListToSubmit).subscribe((result: any) => {
        if (result && result.dealerOrderId != 0) {
          this.transferListToSubmit = [];
          this.toastrService.success('Your order has been saved');
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.router.navigate(['/orders/dealer-order-view', 0, fromOrderId, this.accountId]);
        }
        else {
          this.toastrService.error(result.errorMessage, '', {
            enableHtml: true
          });
          this.isUpdateButtonDisabled = true;
        }
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); });
    }
  }

  //get minimum units exception
  GetEaMinimumUnitException() {
    this.loaderService.setLoaderStatus(true);
    let payload = []
    this.dealerOrderItemList.filter(x => x.dealerOrderID > 0 && x.shipToAccount > 0).map((x) => {
      let tempObj = {
        'dealerOrderItemId': x.dealerOrderItemId,
        'accountNumber': x.shipToAccount,
        'itemId': x.itemID,
      }
      payload.push(tempObj)
    })
    this.subscription.push(this.dealerService.getEaMinimumUnitException(payload).subscribe(results => {
      this.minimumUnitsExceptionData = results;
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    })));
  }

  // Navigate to Grower Order page on click of detail grower section
  navigateToGrowerOrder(grower) {
    this.router.navigate(['/orders/grower-order-detail', 0, grower.growerOrderID]);
  }

  // Bind Data source and created the clone of object
  bindDataSource(orderList: any, isClone: boolean, isFirstCopy: boolean) {
    if (orderList && orderList != null) {
      this.dealerOrderDS = new MatTableDataSource(JSON.parse(JSON.stringify(orderList)));
      if (this.dealerOrderDS.data.length > 0) {
        this.disablecheckbox = false;
      }
      else {
        this.disablecheckbox = true;
      }
      this.dealerOrderDS.filterPredicate = (data: any, filter: any) => {
        let counter = 0;
        const groupFilterSource = JSON.parse(JSON.stringify(this.dealerOrderDS.data));
        const groupName = data.productLine.toLowerCase();
        for (let i = 0; i < groupFilterSource.length; i++) {
          if (groupFilterSource[i].productLine.toLowerCase() == groupName
            && (groupFilterSource[i].ProductNameFilter == ''
              || (groupFilterSource[i].ProductNameFilter.toLowerCase().indexOf(filter.ProductNameFilter.toLowerCase()) > -1))) {
            counter = counter + 1;
          }
        }
        let maturity = 0;
        if (data.ProductNameFilter == null || data.ProductNameFilter == 'undefined') {
          data.ProductNameFilter = '';
        }
        if (data.technology == null || data.technology == 'undefined') {
          data.technology = '';
        }
        if (filter.TechnologyList != null && filter.TechnologyList != '') {
          var technologyFilter = filter.TechnologyList.trim().toLowerCase().split(',');
        }
        if (!this.isNumber(data.maturity)) {
          maturity = 0;
        }
        else {
          maturity = data.maturity;
        }
        if (((data.ProductNameFilter == ''
          && counter > 1)
          || (data.ProductNameFilter.toLowerCase().indexOf(filter.ProductNameFilter.toLowerCase()) > -1))
          && (filter.MarketingBrandList.length == 0 || (filter.MarketingBrandList.indexOf(data.marketingBrand) > -1))
          && (filter.PackageSizeList.length == 0 || (filter.PackageSizeList.indexOf(data.packageSize) > -1))
          && (filter.TechnologyList == null || filter.TechnologyList == '' || (technologyFilter.find(a => data.technology.trim().toLowerCase().includes(a))))
          && (filter.TreatmentList.length == 0 || (filter.TreatmentList.indexOf(data.treatment) > -1))
          && (filter.SeedSizeList.length == 0 || (filter.SeedSizeList.indexOf(data.seedSize) > -1))
          && (filter.ProductLineList.length == 0 || (filter.ProductLineList.indexOf(data.productLine) > -1))
          && ((filter.MaturityMin == null && (maturity == null))
            || (filter.MaturityMin == null && (maturity != null))
            || (filter.MaturityMin == null && (filter.MaturityMax != null))
            || (filter.MaturityMin != null && (filter.MaturityMax == null))
            || ((filter.MaturityMin != null && filter.MaturityMax != null) && maturity != null && +maturity >= +filter.MaturityMin))
          && ((filter.MaturityMax == null && (maturity == null))
            || (filter.MaturityMax == null && (maturity != null))
            || (filter.MaturityMin == null && (filter.MaturityMax != null))
            || (filter.MaturityMin != null && (filter.MaturityMax == null))
            || ((filter.MaturityMax != null && filter.MaturityMin != null) && maturity != null && +maturity <= +filter.MaturityMax))
        ) {
          if (data.isProductDeactivated === false
            || (data.deactivationType == null || data.deactivationType.trim().toLowerCase() == 'partial')) {
            this.filterDealerOrderDSitems.push(data);
          }

          if (data.isGroupBy != true) {
            this.totalProduct = this.totalProduct + 1;
            this.totalDealerUnits = this.totalDealerUnits + parseInt(data.dealerUnits);
          }
          else if (counter <= 1) {
            return false;
          }
          return true;
        }
        else {
          return false;
        }
      };
    };

    this.dealerOrderDSLength = this.filterDealerOrderDSitems.filter(x => x.isGroupBy != true).length;

    this.applyFilterData(this.productFilters);
    // created deep copy
    if (isClone) {
      this.dealerOrderListCopy = JSON.parse(JSON.stringify(orderList));
      this.concatedList = this.dealerOrderDataCopy;
      if (this.newlyAdded && this.newlyAdded.length > 0) { this.concatedList = this.concatedList.concat(this.newlyAdded); }
    }

    if (isFirstCopy) {
      this.dealerOrderDataCopy = JSON.parse(JSON.stringify(orderList));
      this.concatedList = this.dealerOrderDataCopy;
    }
  }

  // show Item Details
  showItemDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  // Apply Filter
  applyFilterData(filterValue: string) {
    this.filterDealerOrderDSitems = [];
    this.totalProduct = 0;
    this.totalDealerUnits = 0;
    this.dealerOrderDS.filter = filterValue;
    this.selectedCount = 0;
    this.dealerOrderDSLength = this.filterDealerOrderDSitems.filter(x => x.isGroupBy != true).length;
    this.filterDealerOrderDSitems.forEach(item => {
      if (item.isSelected) {
        this.selectedCount = this.selectedCount + 1;
      }
    });
  }

  // Update grid value from action on toolKit
  setAllFields(field: string, value: any) {
    const refreshData = [];
    let isDeleted = true;  // Set default delete validation flag
    switch (field) {
      case 'delete':
        this.filterDealerOrderDSitems.forEach(item => {
          if (item.isGroupBy != true && item.isSelected && value == true) {
            // Implemented code to validate item for modifiable unit  -- Ashutosh
            if (item.ChangeType != 'ADD') {
              const line = this.validateDeletingLineItem(item, 'dealerUnit');
              if (line.lineErrors.errors.length == 0) {
                item.dealerUnits = 0;
                item.isSelected = false;
              }
              else {
                isDeleted = false;
              }
            }
            else {
              refreshData.push(item.itemID);
            }
          }
          else {
            this.filterDealerOrderDSitems.forEach(item => {
              item.showCutCancelOverWarning = false;
            });
          }
        });
        break;
      default:
        break;
    }

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });

    this.filterDealerOrderDSitems.forEach(product => {
      product.ProductNameFilter = (product.brand != null ? product.brand : '');
    });

    if (value === true && isDeleted) {
      // To only delete selected items no those which have 0 quanity -- Ashutosh
      this.bindDataSource(this.dealerOrderDS.data.filter(x => !refreshData.includes(x.itemID)), false, false);
    }
    this.tabNode = '';
  }

  // Show tab
  showTab(tabid: string) {
    this.tabNode = tabid;
    if (tabid === 'delete') {
      this.filterDealerOrderDSitems.forEach(item => {
        if (item.isGroupBy != true && item.isSelected) {
          if (item.cutCancelOverWarning) {
            item.showCutCancelOverWarning = true;
          }
        }
      });
    }
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // validation on Add/Update product
  validateOrder(validateField) {
    let isValidated = true; // true;
    if (this.dealerOrderDS.data && this.dealerOrderDS.data.length > 0) {
      isValidated = true;
      // TODO: Commented error handling to validate later
      this.dealerOrderDS.data.forEach(x => {
        if (x.isGroupBy != true) {
          x = this.validateLineItem(x, validateField, '');
          if (x.lineErrors.errors.length > 0) {
            isValidated = false;
          }
        }
      });
    }
    else {
      if (this.dealerOrderId == 0) {
        isValidated = false;
        this.toastrService.warning('No Products added to place order');
      }
    }

    return isValidated;
  }

  // Line item validation
  validateLineItem(item: any, validateField, action) {
    // let oldLineValue = this.dealerOrderListCopy.filter(x => x.rowId == item.rowId)[0];
    let oldLineValue = this.dealerOrderListCopy.filter(x => x.itemID == item.itemID)[0];

    if (validateField == 'dealerUnit' && (item.dealerModifiableUnits < item.dealerUnits) &&
      (item.deactivationType != null && item.deactivationType.trim().toLowerCase() == 'partial')) {
      const valueBeforeInc = oldLineValue.dealerUnits;
      const dealerUnits = Math.ceil(item.dealerUnits / +item.conv) * +item.conv;
      if (action === 'focusout') { // when focus lost handled that case
        if (+valueBeforeInc <= +dealerUnits) {
          item.dealerUnits = +valueBeforeInc;

          this.toastrService.warning('Can\'t increase dealer unit\'s for partial deactivated item.');
        }
        else if (+item.dealerModifiableUnits <= +dealerUnits) {
          item.dealerUnits = +dealerUnits;
        }

        if (item.dealerUnits != 0 && item.dealerUnits % item.conv != 0 && item.conv > 0) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
          item.lineErrors.errors.push({ id: 'conv', error: 'Please re-enter your Dealer Units in multiples of ' + item.conv });
        }
        if (item.lineErrors.errors.length > 0) {
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
          this.errorMsgs.push(item.lineErrors);
        }
        else {
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
          this.setCount();
        }
        this.getCommonErrors(this.errorMsgs);
      }
      if (action === 'increase' && +valueBeforeInc < +dealerUnits) { // increase action case
        this.toastrService.warning('Can\'t increase dealer unit\'s for partial deactivated item.');
      }
      return false;
    }

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldGeuValue: oldLineValue.dealerUnits, newGeuValue: item.dealerUnits });

    if (validateField != '') {
      if (validateField == 'dealerUnit') {
        if (item.dealerUnits < oldLineValue.dealerUnits && ((oldLineValue.dealerUnits - item.dealerUnits) > item.dealerModifiableUnits)) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'dealerUnits');
          item.lineErrors.errors.push({
            id: 'dealerUnits', error: 'Can\'t reduce the quantity more than what has been shipped. ' + item.dealerModifiableUnits + ' Equivalent Units left to be shipped.'
          });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'dealerUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }

        if (item.dealerUnits != 0 && item.dealerUnits % item.conv != 0 && item.conv > 0) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
          item.lineErrors.errors.push({ id: 'conv', error: 'Please re-enter your Dealer Units in multiples of ' + item.conv });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }
        if (item.dealerUnits !== '' && !parseInt(item.dealerUnits)) {
          if (this.dealerOrderDataCopy) {
            this.dealerOrderDataCopy.forEach(y => {
              if (y.dealerOrderItemId == item.dealerOrderItemId) {
                if ((item.dealerUnits < y.dealerUnits) && item.cutCancelOverWarning) {
                  item.showCutCancelOverWarning = true;
                }
                else {
                  item.showCutCancelOverWarning = false;
                }
              }
            });
          }
          // if (item.dealerUnits < item.originalDealerUnits) {
          //  if (item.cutCancelOverWarning) {
          //    item.showCutCancelOverWarning = true;
          //  }
          // } else {
          //  item.showCutCancelOverWarning = false;
          // }
        }
      }
    }
    else {
      if (item.dealerUnits < oldLineValue.dealerUnits && (oldLineValue.dealerUnits - item.dealerUnits) > item.dealerModifiableUnits) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'dealerUnits');
        item.lineErrors.errors.push({
          id: 'dealerUnits', error: 'Can\'t reduce the quantity more than what has been shipped. ' + item.dealerModifiableUnits + ' Equivalent Units left to be shipped.'
        });
      }

      if (item.dealerUnits != 0 && item.dealerUnits % item.conv != 0 && item.conv > 0) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
        item.lineErrors.errors.push({ id: 'conv', error: 'Please re-enter your Dealer Units in multiples of ' + item.conv });
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    else {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.setCount();
    }

    item.isLessDealerUnits = item.originalDealerUnits > item.dealerUnits;
    if (!item.isLessDealerUnits) {
      item.isEaReducedModifiableChecked = false;
    }
    this.validateMinimumUnitException(item);
    this.errorMsgs.sort(function (row1, row2) {
      return row1.rowId - row2.rowId;
    });
    this.getCommonErrors(this.errorMsgs);
    return item;
  }

  // To validate modifiable unit while deleting item
  validateDeletingLineItem(item: any, validateField) {
    if (validateField != '') {
      if (validateField == 'dealerUnit') {
        if ((item.dealerUnits != undefined || (item.dealerUnits != undefined && item.dealerUnits != 0))
          && (item.dealerModifiableUnits == 0 || (item.dealerModifiableUnits != item.dealerUnits))
          && (item.dealerModifiableUnits != 0 && item.dealerUnits != 0)) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'dealerUnits');
          item.lineErrors.errors.push({
            id: 'dealerUnits', error: 'Line item can not be reduced as the product has already been released/shipped.'
          });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'dealerUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }
      }
    }
    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    else {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.setCount();
    }

    this.errorMsgs.sort(function (row1, row2) {
      return row1.rowId - row2.rowId;
    });
    this.getCommonErrors(this.errorMsgs);

    return item;
  }

  validateMinimumUnitException(item) {
    var minimumUnitsData = this.minimumUnitsExceptionData.find((y) => y.itemId == item.itemID);
    if (item.isLessDealerUnits && item.isEaReducedModifiableChecked && minimumUnitsData) {
      var allGroupItems = JSON.parse(JSON.stringify(this.dealerOrderDS.data.filter(x => x.dealerOrderID > 0 && x.shipToAccount > 0 && x.marketingBrand == item.marketingBrand && x.productLine == item.productLine && x.eaModifiableUnits > 0 && x.isEaReducedModifiableChecked)));
      allGroupItems.map(x => {
        x['reduceEAModifiableUnits'] = x.originalDealerUnits - x.dealerUnits <= x.eaModifiableUnits ? x.originalDealerUnits - x.dealerUnits : x.eaModifiableUnits;
      });
      let reduceEAModifiableUnits = allGroupItems.reduce((sum, item) => sum + +item.reduceEAModifiableUnits, 0);
      let totalEAUnits = +minimumUnitsData.totalEAUnit - +reduceEAModifiableUnits;
      let minimumUnits = +minimumUnitsData.minimumUnit;
      if (totalEAUnits < minimumUnits) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'eaUnits');
        item.lineErrors.errors.push({
          id: 'eaUnits', error: 'Total EA Units ' + totalEAUnits + ' can not be less than ' + minimumUnits + ' Units.'
        });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'eaUnits');
        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      }
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'eaUnits');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    return item;
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.dealerOrderListCopy.length > 0 && this.dealerOrderDS.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        // let oldLineValue = this.dealerOrderListCopy.filter(x => x.rowId == element.rowId)[0];
        let oldLineValue = this.dealerOrderListCopy.filter(x => x.itemID == element.itemID)[0];

        // get current object index
        const currentLineIndex = this.dealerOrderDS.data.findIndex(x => x.rowId == element.rowId);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.dealerOrderDS.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.bindDataSource(this.dealerOrderDS.data, false, false);

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        // this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.dealerOrderListCopy));

        // To hide all errors after revert all changes
        this.dealerOrderDS.data.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            var index = x.lineErrors.rowId - 1;
            // let oldLineValue = this.dealerOrderListCopy.filter(x => x.rowId - 1 == index)[0];
            let oldLineValue = this.dealerOrderListCopy.filter(y => y.itemID == x.itemID)[0];
            this.dealerOrderDS.data[index] = JSON.parse(JSON.stringify(oldLineValue));
            this.showHideLineError(index);
          }
        });

        this.bindDataSource(this.dealerOrderDS.data, false, false);
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
    this.activeEditToolKit(false);
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#orderView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Validate select count and set the value
  validateSelectedCount(element) {
    if (element.isSelected != true && !this.accessTypeMode) {
      element.isSelected = true;
      this.activeEditToolKit(true);
    }
  }

  // Set the total item count
  setCount() {
    this.totalProduct = 0;
    this.totalDealerUnits = 0;
    this.totalProduct = this.dealerOrderDS.data.filter(x => x.isGroupBy != true).length;
    this.dealerOrderDS.data.forEach(x => {
      if (x.isGroupBy != true) {
        this.totalDealerUnits = this.totalDealerUnits + +(x.dealerUnits);
      }
    });
  }

  // Enable tool kit on single
  activeEditToolKit(isChecked: boolean) {
    this.isSearchClicked = false;
    if (this.dealerOrderDS) {
      this.selectedCount = 0;
      this.filterDealerOrderDSitems.forEach(item => {
        if (item.isSelected) {
          this.selectedCount = this.selectedCount + 1;
        }
      });
      this.dealerOrderDSLength = this.filterDealerOrderDSitems.filter(x => x.isGroupBy != true).length;

      if (this.selectedCount === this.dealerOrderDSLength && this.dealerOrderDSLength > 0) {
        this.EnableAllEditToolKit(true);
      }
    }
    else {
      if (isChecked) {
        this.selectedCount = this.selectedCount + 1;
      }
      else {
        this.selectedCount = this.selectedCount - 1;
      }
    }
    this.editToolKit = (this.selectedCount > 0);
    this.checkEaUnitsExist();
  }

  // EnableAllEditToolKit
  EnableAllEditToolKit(isChecked: boolean) {
    this.isSearchClicked = false;
    if (isChecked) {
      this.editToolKit = true;
      this.selectedCount = 0;
      this.filterDealerOrderDSitems.forEach(item => {
        if (item.isGroupBy != true
          && (item.isProductDeactivated == false
            || (item.deactivationType == null || item.deactivationType.trim().toLowerCase() == 'partial'))) {
          this.selectedCount = this.selectedCount + 1;
          item.isSelected = true;
        }
      });
      this.dealerOrderDSLength = this.filterDealerOrderDSitems.filter(x => x.isGroupBy != true && !x.isProductDeactivated).length;
    }
    else {
      this.editToolKit = false;
      this.filterDealerOrderDSitems.forEach(item => {
        if (item.isGroupBy != true) {
          item.isSelected = false;
        }
      });
      this.selectedCount = 0;
    }
    this.checkEaUnitsExist();
  }

  // Check for Dealer order line having Ea units > 0
  checkEaUnitsExist() {
    if (this.isEaUnitsEligible) {
      this.isEaUnitsExist = this.filterDealerOrderDSitems.filter(x => x.isSelected && x.eaUnits > 0).length > 0 ? true : false;
    }
  }
  // Clear Product Filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
      if (this.filterValueList.length < 1) {
        // remove all filter
      }
    }
  }

  // Remove Product Filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        this.productFilters.ProductNameFilter = '';
        break;
      case 'Marketing Brand':
      case 'Manufacturer':
        this.productFilters.MarketingBrandList = [];
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        break;
      case 'Technology':
        this.productFilters.TechnologyList = '';
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        break;
      case 'Maturity':
        this.productFilters.MaturityMin = null;
        this.productFilters.MaturityMax = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        break;
      default:
        break;
    }
  }

  // Reset Product Filter
  resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'IsAvailabilityChecked': false,
      'ProductNameFilter': '',
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': '',
      'TreatmentList': [],
      'ProductLineList': [],
      'MaturityMin': null,
      'MaturityMax': null,
    };
  }

  // keep Product Filter
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductNameFilter && this.productFilters.ProductNameFilter != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductNameFilter);
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
        }
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }
        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.TechnologyList);
        }
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
        }
        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }
        let maturityMin = '';
        let maturityMax = '';
        if (this.productFilters.MaturityMin != null && this.productFilters.MaturityMax != null) {
          maturityMin = this.productFilters.MaturityMin;
          maturityMax = this.productFilters.MaturityMax;
          this.filterValueList.push('Maturity : (' + maturityMin + ') - (' + maturityMax + ')');
        }
      }
    }
    this.applyFilterData(this.productFilters);

    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Clear All Filter
  clearAllFilter() {
    this.dealerOrderDSLength = this.dealerOrderDS.data.filter(x => x.isGroupBy != true).length;
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.transferListToSubmit = new Array();
    this.isInternalTransferClicked = false;
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
  }

  // Product Search
  selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.ProductNameFilter = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.ProductNameFilter = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.ProductNameFilter = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }
    this.keepFilter();
  }

  selectTechnology($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.TechnologyList = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.TechnologyList = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.TechnologyList = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }
    this.keepFilter();
  }

  // Validate number
  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  // Is group
  isGroup(index, item): boolean {
    return item.isGroupBy;
  }

  // Open Dealer Order Transfer Slider model
  openDealerOrderTransferSliderModel() {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });
        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.revertToPreviousState(false);
            this.transferProductChanges();
          }
        }));
      }
      else {
        this.transferProductChanges();
      }
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  openInternalOrderTransferSliderModel() {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });
        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.revertToPreviousState(false);
            this.internalTransferProductChanges();
          }
        }));
      }
      else {
        this.internalTransferProductChanges();
      }
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  internalTransferProductChanges() {
    if (this.isInternalTransfer == true) {
      const data = this.filterDealerOrderDSitems.filter(x => x.isSelected);
      data.forEach(x => {
        x.modifiableUnit = 0;
        x.modifiableUnit = (x.netBEU - x.shippedUnits);
      });
      const lst = data.filter(x => x.isSelected && x.modifiableUnit != 0);
      if (lst && lst.length == 0) {
        this.toastrService.warning('No Item found with Modifiable Units.');
        return false;
      }
      this.selectedOrderToOrderItemList = [];

      this.sliderModelService.initializeComponentVal(this.selectedDealerAccountNo);

      lst.forEach(item => {
        if (item.isSelected
          || (item.isProductDeactivated === true && (item.deactivationType != null && item.deactivationType.trim().toLowerCase() == 'partial'))) {
          this.selectedOrderToOrderItemList.push(item);
        }
      });

      this.isInternalTransferClicked = true;
      this.sliderModelService.setOrder2OrderTranferUnit<any>(this.selectedOrderToOrderItemList);
      this.sliderModelService.setAccountInfo<AccountVM>(this.selAccountObj);
      this.sliderModelService.activeSlider('dealerOrderInternalTransferSlider');
    }
    else {
      this.toastrService.error('User not eligible for internal transfer.');
    }
  }

  openEASwapProduct() {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      const data = this.filterDealerOrderDSitems.filter(x => x.isSelected);
      //data.forEach(x => {
      //  x.modifiableUnit = 0;
      //  x.modifiableUnit = (x.netBEU - x.plannedUnits - x.shippedUnits);
      //});
      const lst = data.filter(x => x.isSelected && x.eaModifiableUnits != 0);
      if (lst && lst.length == 0) {
        this.toastrService.warning('No Item found with EA Modifiable Units.');
        return false;
      }

      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });

        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.tabNode = '';
            this.revertToPreviousState(false);
            this.eaSwapProductSliderModelService.initializeProductChangeVal({
              companyCode: this.headerCompany,
              cropYear: +this.headerYear,
              accountNo: +this.selectedDealerAccountNo,
              page: 'dealerSlider',
              data: [],
              action: '',
              dealerData: lst as DealerOrderItemVM[],
              isAccountRIB: false
            });
            this.dealerService.selectedDealerOrderId = (this.dealerOrderId != undefined && this.dealerOrderId != 0) ? this.dealerOrderId : 0;
            this.eaSwapProductSliderModelService.activeSlider('EaSwapProductSlider');
          }
        }));
      }
      else {
        this.tabNode = '';
        this.eaSwapProductSliderModelService.initializeProductChangeVal({
          companyCode: this.headerCompany,
          cropYear: +this.headerYear,
          accountNo: +this.selectedDealerAccountNo,
          action: '',
          page: 'dealerSlider',
          data: [],
          dealerData: lst as DealerOrderItemVM[],
          isAccountRIB: false
        });

        this.eaSwapProductSliderModelService.activeSlider('EaSwapProductSlider');
      }
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  openModifyDecreaseUnit(type: string) {
    const lst = this.dealerOrderDS.data.filter(x => x.isSelected && x.eaModifiableUnits != 0);
    if (type != 'Modify' && lst && lst.length == 0) {
      this.toastrService.warning('No Item found with EA Modifiable Units.');
      return false;
    }

    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
      });

      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.tabNode = '';
          this.revertToPreviousState(false);
          this.setDataModelForModify(type);
        }
      }));
    }
    else {
      this.tabNode = '';
      this.setDataModelForModify(type);
    }
  }

  setDataModelForModify(type: string) {
    this.dealerService.isNaveForModify = type == 'Modify';
    if (this.dealerService.isNaveForModify) {
      this.dealerService.selectedProductForModificaion = this.dealerOrderDS.data.filter((x) => x.isSelected && x.eaUnits > 0 && !x.isGroupBy)
        .sort((a, b) => a.productLine.toLowerCase().localeCompare(b.productLine.toLowerCase())
          || a.marketingBrand.toLowerCase().localeCompare(b.marketingBrand.toLowerCase())
          || a.brand.toLowerCase().localeCompare(b.brand.toLowerCase())
          || a.seedSize.toLowerCase().localeCompare(b.seedSize.toLowerCase())
          || a.treatment.toLowerCase().localeCompare(b.treatment.toLowerCase())
          || a.packageSize.toLowerCase().localeCompare(b.packageSize.toLowerCase()));
    }
    else {
      this.dealerService.selectedProductForModificaion = this.dealerOrderDS.data.filter((x) => x.isSelected && x.eaModifiableUnits > 0 && !x.isGroupBy)
        .sort((a, b) => a.productLine.toLowerCase().localeCompare(b.productLine.toLowerCase())
          || a.marketingBrand.toLowerCase().localeCompare(b.marketingBrand.toLowerCase())
          || a.brand.toLowerCase().localeCompare(b.brand.toLowerCase())
          || a.seedSize.toLowerCase().localeCompare(b.seedSize.toLowerCase())
          || a.treatment.toLowerCase().localeCompare(b.treatment.toLowerCase())
          || a.packageSize.toLowerCase().localeCompare(b.packageSize.toLowerCase()));
    }

    this.dealerService.selectedDealerOrderId = this.dealerOrderId;
    this.dealerService.selectedProductForModificaionOrderNumber = this.dealerOrderData?.orderNumber;
    this.dealerService.selectedProductForModificaionAccountNumber = this.selAccountObj?.accountNumber;
    this.eaProductModifyDecreaseUnitSliderModelService.activeSlider('EaProductModifyDecreaseUnitSlider');
  }

  openAddEAProduct() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
      });

      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.revertToPreviousState(false);
          this.eaAddProductSliderModelService.initializeProductChangeVal({
            companyCode: this.headerCompany,
            cropYear: +this.headerYear,
            accountNo: +this.selectedDealerAccountNo,
            page: 'dealerSlider',
            data: [],
            action: '',
            dealerData: [],
            isAccountRIB: false
          });
          this.dealerService.selectedDealerOrderId = (this.dealerOrderId != undefined && this.dealerOrderId != 0) ? this.dealerOrderId : 0;
          this.eaAddProductSliderModelService.activeSlider('EaAddProductSlider');
        }
      }));
    }
    else {
      this.eaAddProductSliderModelService.initializeProductChangeVal({
        companyCode: this.headerCompany,
        cropYear: +this.headerYear,
        accountNo: +this.selectedDealerAccountNo,
        action: '',
        page: 'dealerSlider',
        data: [],
        dealerData: [],
        isAccountRIB: false
      });
      this.dealerService.selectedDealerOrderId = (this.dealerOrderId != undefined && this.dealerOrderId != 0) ? this.dealerOrderId : 0;
      this.eaAddProductSliderModelService.activeSlider('EaAddProductSlider');
    }
  }

  CheckInternalTransfer() {
    this.subscription.push(this.dealerService.checkUser4InternalTransfer().subscribe(results => {
      if (results == true) {
        this.isInternalTransfer = true;
      }
      else {
        this.isInternalTransfer = false;
      }
    }, (error => {
      LolLoggerService.error(error);
    })));
  }

  // Transfer Product change
  transferProductChanges() {
    const data = this.filterDealerOrderDSitems.filter(x => x.isSelected);
    data.forEach(x => {
      x.modifiableUnit = 0;
      x.modifiableUnit = (x.netBEU - x.shippedUnits);
    });
    const lst = data.filter(x => x.isSelected && x.modifiableUnit != 0);
    if (lst && lst.length == 0) {
      this.toastrService.warning('No Item found with Modifiable Units.');
      return false;
    }
    this.selectedOrderToOrderItemList = [];
    this.sliderModelService.initializeComponentVal(this.selectedDealerAccountNo);

    lst.forEach(item => {
      if (item.isSelected
        || (item.isProductDeactivated === true && (item.deactivationType != null && item.deactivationType.trim().toLowerCase() == 'partial'))) {
        this.selectedOrderToOrderItemList.push(item);
      }
    });

    this.sliderModelService.setOrder2OrderTranferUnit<any>(this.selectedOrderToOrderItemList);
    this.sliderModelService.setAccountInfo<AccountVM>(this.selAccountObj);
    this.sliderModelService.activeSlider('dealerOrderTransferSlider');
  }

  // To show hide product deactivation info block
  blockHideShow(id: number, flag: boolean) {
    if (flag) {
      $('#sub_' + id).addClass('showHide');
      $('#main_' + id).addClass('prod-unavail-info-hover');
    }
    else {
      $('#sub_' + id).removeClass('showHide');
      $('#main_' + id).removeClass('prod-unavail-info-hover');
    }
  }

  // To show hide product deactivation info block
  blockHideShowPlus(id: number, flag: boolean) {
    if (flag) {
      $('#outer_' + id).addClass('showHideDiv');
      $('#sub_' + id).addClass('showHide');
      $('#main_' + id).addClass('prod-unavail-info-hover');
    }
    else {
      $('#outer_' + id).removeClass('showHideDiv');
      $('#sub_' + id).removeClass('showHide');
      $('#main_' + id).removeClass('prod-unavail-info-hover');
    }
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    return this.isNotValid;
  }

  // Verfiy Add Product button Access
  AddProductAccess() {
    const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    if (evolveAccessData) {
      this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
      this.isAddProductAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.DEALER_ORDER_ADD_PRODUCT, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
    }
  }

  // filter the dealer order lines on the basis of "Dislpay Non-Zero Lines only" checkbox
  public filterDealerOrderDetail(getZeroQtyRecordsChecked: boolean) {
    this.ignoreZeroQtyRecords = getZeroQtyRecordsChecked;
    this.totalProduct = 0;
    this.totalDealerUnits = 0;

    if (getZeroQtyRecordsChecked) {
      // this.dealerOrderDS.data = this.dealerOrderDataCopy.filter(x => x.dealerUnits > 0);
      this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.concatedList.filter(x => x.dealerUnits > 0)));
    } else {
      // this.dealerOrderDS.data = this.dealerOrderDataCopy;
      this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.concatedList));
    }
    // check for EA checkbox
    if (this.ignoreZeroEaUnitRecords) {
      this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.dealerOrderDS.data.filter(x => x.eaUnits > 0)));
    }

    this.selectedCount = this.dealerOrderDS.data.filter(i => i.isSelected == true).length;
    this.dealerOrderDSLength = this.dealerOrderDS.data.filter(x => x.isGroupBy != true).length;
    this.setCount();
  }
  // filter the dealer order lines on the basis of "Display Early Advantage Units" checkbox
  public filterEADealerOrderDetail(getZeroQtyRecordsChecked: boolean) {
    this.ignoreZeroEaUnitRecords = getZeroQtyRecordsChecked;
    this.totalProduct = 0;
    this.totalDealerUnits = 0;

    if (getZeroQtyRecordsChecked) {
      this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.concatedList.filter(x => x.eaUnits > 0)));
    } else {
      this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.concatedList));
    }
    // check for Dealer Order checkbox
    if (this.ignoreZeroQtyRecords) {
      this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.dealerOrderDS.data.filter(x => x.dealerUnits > 0)));
    }
    this.selectedCount = this.dealerOrderDS.data.filter(i => i.isSelected == true).length;
    this.dealerOrderDSLength = this.dealerOrderDS.data.filter(x => x.isGroupBy != true).length;
    this.setCount();
  }

  public validateEaReducedUnitChange(item: any) {
    this.validateMinimumUnitException(item);
    this.errorMsgs.sort(function (row1, row2) {
      return row1.rowId - row2.rowId;
    });
    this.getCommonErrors(this.errorMsgs);
  }

  bindTransferList(transferList) {
    if (transferList != null && transferList.length > 0) {
      let transferProdList = [];
      transferList.forEach(item => {
        let orders = this.dealerOrderDS.data.filter(f => f.dealerOrderItemId == item.dealerOrderItemId);
        if (orders != null && orders.length > 0) {
          let order = orders[0]
          order.dealerModifiableUnits = item.dealerModifiableUnits;
          order.dealerUnits = item.dealerUnits;
          order.netBEU = item.dealerUnits;
          order.eaModifiableUnits = item.eaModifiableUnits;
          order.eaUnits = item.eaUnits;
          order.longShortPosition = item.longShortPosition;
          order.myDealerBucket = item.myDealerBucket;
          order.myDealerBucketQty = item.myDealerBucketQty;
          transferProdList.push(order);
        }
      });

      this.bindDataSource(transferProdList, false, false);
      this.editToolKit = false;
      this.isReadOnly = true;
    }
  }

  backToOrder() {
    this.commonService.setSeedOrderTabIndex(1);
    let gmk = 0;
    let dealerAc = 0;
    if (this.growerGMK && this.growerGMK > 0) {
      gmk = this.growerGMK;
    }
    if (this.selectedDealerAccount && this.selectedDealerAccount > 0) {
      dealerAc = this.selectedDealerAccount;
    }

    //this.router.navigate(['/landing-data?growerGMK=' + gmk + '&dealerAccount=' + dealerAc]);
    this.router.navigate(['/landing-data'], {
      queryParams: {
        growerGMK: gmk,
        dealerAccount: dealerAc
      }
    });
  }

  isInWebView(): boolean {
    const ua = navigator.userAgent || '';

    // React Native WebView
    if ((window as any).ReactNativeWebView) return true;

    // iOS WebView: AppleWebKit but NOT Safari
    const isIOS = /iPhone|iPod|iPad/i.test(ua);
    const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView: look for 'wv' or no 'Chrome' version string
    const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

    return isIOSWebView || isAndroidWebView;
  }
}
